import { render, staticRenderFns } from "./EmployeeItem.vue?vue&type=template&id=4c125c6c&"
import script from "./EmployeeItem.vue?vue&type=script&lang=js&"
export * from "./EmployeeItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports